export const Open = () => {
  return (
    <div className="flex justify-center p-2 h-screen">
      <iframe
        className="p-4 h-screen w-screen"
        src="https://iframe.dacast.com/live/34722db9-4e7c-5b6a-03b1-492fb511cfd6/76922380-58e6-2ec4-8d22-9bed9032a1c4"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        title="Open"
      />
    </div>
  );
};
